export const throwError = (errorOrMessage: Error | string): never => {
    if (errorOrMessage instanceof Error) {
        throw errorOrMessage;
    } else if (typeof errorOrMessage === 'string') {
        throw new Error(errorOrMessage);
    } else {
        throw new Error('Invalid call to throwError()!');
    }
};
